export const searchInputTokens = {
  'search-height': '36px',
  'search-bg': 'var(--dp-color-background)',
  'search-border-color': 'var(--dp-color-border)',
  'search-border-radius': 'var(--dp-border-radius-lg)',
  'search-icon-color': 'var(--dp-color-text-tertiary)',
  'search-icon-size': '16px',
  'search-clear-btn-color': 'var(--dp-color-text-tertiary)',
  'search-clear-btn-hover': 'var(--dp-color-text-secondary)',
  'search-padding-left': 'var(--dp-spacing-xl)',
} as const;
